import React, { useEffect, useState } from "react";
// import "../style/clientNavbar-style.css";
import { Link, useNavigate } from "react-router-dom";
import { GoogleLogin } from '@react-oauth/google';
import { getInfo } from "../../worker-panel/slice/workerInfoSlice";
import { useSelector, useDispatch } from "react-redux";
import { logout, selectWorkerAuth } from "../../worker-auth/slice/workerAuthSlice";

const WorkerNavbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isWorkerLoggedIn = useSelector(selectWorkerAuth);
  const workerIsVerified = useSelector(
    (state) => state.workerInfo.userData?.is_verify
  );
  // console.log("isWorkerLoggedIn", isWorkerLoggedIn);
  // console.log("workerIsVerified", workerIsVerified);
  const token = localStorage.getItem("token");

  const { userData, loading } = useSelector(
    (state) => state.workerInfo
  );
  const ProfileImage = useSelector(
    (state) => state.workerInfo.userData?.profile
  );

  const Username = useSelector(
    (state) => state.workerInfo.userData?.first_name
  );


  useEffect(() => {
    if (!token) return;

    dispatch(getInfo(token));
  }, [token, dispatch]);

  const userImageUrl = ProfileImage
    ? `${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${userImageUrl}`
    : "/assets/images/default-profile-account.jpg";

  const handleWorkerLogout = () => {
    dispatch(logout());
    navigate("/signin");
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg py-2 py-lg-0 navbar-bottom-shadow">
        <div className="container position-relative px-1">
          {/* <Link to="/"> */}
          <div className="logo me-0 mb-0">
           <a className="navbar-brand d-none d-lg-block" href={process.env.REACT_APP_HOME_URL}>
  <img src="/assets/images/NCAF_Logo_new.png" style={{ width: "180px" }} />
</a>
          </div>
          {/* <a className="navbar-brand logo me-0 py-0 mb-0" href="/provider"><img src="/assets/images/logo.png" className="img-fluid" /></a> */}
          {/* </Link> */}
          <div className="d-flex">
            <div className="d-lg-none"><a href="#" className="text-decoration-none"><img src="/assets/images/header-gmail.svg" alt="..." className="" /></a></div>
            <div className="mx-3 d-lg-none"><a href="#" className="text-decoration-none"><img src="/assets/images/header-call.svg" alt="..." className="" /></a></div>
            <button className="navbar-toggler text-danger p-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
              <img src="/assets/images/menu-arrow.png" className="img-fluid" style={{ position: "relative", top: "-2px" }} />
            </button>
          </div>
          <div className="collapse navbar-collapse justify-content-between" id="navbarCollapse">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center me-2">

              {!isWorkerLoggedIn && (
                <>
                  {/* <li className="nav-item">
                    <Link className="nav-link text-white" to={process.env.REACT_APP_HOME_URL}>Home</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to={process.env.REACT_APP_ABOUT_US}>About Us</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to="/worker-jobs">Jobs</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to={process.env.REACT_APP_CONTACT_US}>Contact Us</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to="/worker-child-care-facilities">Find Child Day Care</Link>
                  </li> */}

                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_NCAF_NETWORKS}>NCAF Network</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_WORKFORCE_ONBOARDING}>Workforce Onboarding</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_BENEFITS_STABILITY}>Benefits Stability</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_ABOUT_US}>About NCAF</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_HELP}>Resources</Link>
                  </li>
                </>
              )}

              {isWorkerLoggedIn && workerIsVerified === 0 && (
                <li className="nav-item">
                  <Link className="nav-link text-white" to="/panel/verify">
                    ID Verification
                  </Link>
                </li>
              )}

              {isWorkerLoggedIn && (
                <>
                  {/* <li className="nav-item">
                    <Link className="nav-link text-white" to="/panel">
                      Dashboard
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to="/worker-jobs">Jobs</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to="/worker-child-care-facilities">Find Child Day Care</Link>
                  </li> */}
                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_NCAF_NETWORKS}>NCAF Network</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_WORKFORCE_ONBOARDING}>Workforce Onboarding</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_BENEFITS_STABILITY}>Benefits Stability</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_ABOUT_US}>About NCAF</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_HELP}>Resources</Link>
                  </li>
                </>
              )}

            </ul>

            {isWorkerLoggedIn ? (
              <div className="d-flex log-in">
               <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-2 mt-3 mt-lg-0">
                  <div className="d-flex align-items-center">

                    <div className="font-size-14 font-weight-normal line-hight-3 text-whightlight me-2">
                      <h2 className="font-weight-semibold font-size-18 mb-0 line-hight-2 text-white">
                        {userData.first_name || "Guest"}
                      </h2>
                    </div>

                    <div className="me-3">
                      <img src={userImageUrl} alt="Profile" className="img-fluid"
                        style={{
                          height: "35px",
                          width: "35px",
                          borderRadius: "8px"
                        }}
                      />
                    </div>

                    <div>
                      <button
                        className="btn btn-outline-light-login"
                        onClick={handleWorkerLogout}
                      >
                        Logout
                        <i className="fa fa-sign-out ms-2" aria-hidden="true"></i>
                      </button>
                    </div>

                    {/* <div className="dropdown m-2">
                      <button
                        className="btn btn-sm btn-outline-light dropdown-toggle"
                        type="button"
                        id="providerDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        ☰
                      </button>

                      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="providerDropdown">
                        <li>
                          <Link className="dropdown-item" to="/panel/editprofile"> My Account </Link>
                        </li>
                        <li className="mt-2" onClick={handleWorkerLogout}>
                          <button className="dropdown-item">
                            Logout
                          </button>
                        </li>
                      </ul>
                    </div> */}

                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex log-in">
                <div className="d-flex align-items-center ps-3 ps-lg-0 py-3 py-lg-0">

                  <div className="dropdown  me-2">
                    <button className="btn btn-outline-light-login font-weight-medium rounded"
                      data-bs-toggle="dropdown" id="loginDropdown">
                      <span className="d-block py-1 px-2">Register <i className="ms-1 fa fa-caret-down" aria-hidden="true"></i></span>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="loginDropdown">
                      <li>
                        <Link className="dropdown-item py-2 px-3" to={process.env.REACT_APP_EMPLOYER_SIGNUP}>Employer</Link>
                      </li>
                      {/* <li>
                        <Link className="dropdown-item py-2 px-3" to="#">Teacher</Link>
                      </li> */}
                      <li>
                        <Link className="dropdown-item py-2 px-3" to={process.env.REACT_APP_WORKER_SIGNUP}>Worker</Link>
                      </li>
                      <li>
                        <Link className="dropdown-item py-2 px-3" to={process.env.REACT_APP_Volunteer_SIGNUP}>Volunteer</Link>
                      </li>
                      {/* <li>
                        <Link className="dropdown-item py-2 px-3" to="/worker-bot">Worker Bot</Link>
                      </li>
                      <li>
                        <Link className="dropdown-item py-2 px-3" to="/readiness-compliance-assistant">Snapshot Bot</Link>
                      </li>
                      <li>
                        <Link className="dropdown-item py-2 px-3" to="/state-resource-guide">State Bot</Link>
                      </li> */}
                    </ul>
                  </div>
                  <Link to="/signin">
                    <button className="btn btn-outline-light text-white font-weight-medium rounded"><span className="d-block py-1 px-2">Sign In</span></button>
                  </Link>
                  <Link to={process.env.REACT_APP_PARTICIPATION_PAGE}>
                    <button className="btn btn-outline-light-donation text-white font-weight-medium rounded ms-2"><span className="d-block py-1 px-2" >Join NCAF</span></button>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default WorkerNavbar;
